import axios from 'axios';
import React from 'react';
import { toast } from 'react-hot-toast';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

const Unsubscribe = ({ baseURL }) => {
  const {
    companyid, contactid, type, 
  } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleUnsubscribe = async () => {
    const payloadSms = {
      text_opt_in: false,
    };
    const payloadEmail = {
      email_opt_in: false,
    };
    const response = await axios.put(
      `${baseURL}/contacts/unsubscribe/campaign/${type}/${companyid}/${contactid}`,
      type === 'sms' ? payloadSms : payloadEmail,
      {
        params: {
          run_id: searchParams.get('run_id'),
          node_id: searchParams.get('node_id'),
          workflow_id: searchParams.get('workflow_id'),
          template_id: searchParams.get('template_id'),
        },
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',         
        },
      },
    );
    console.log('response',response);
    if (response.data.status === 'success') {
      toast.success(`${response.data.data.first_name} have been unsubscribed successfully`);
    }
  };
  return (
    <div className="qs-page">
      <div className="qs-card max-w-[440px]">
        <div className="qs-card-body space-y-6">
          <div className="qs-title">
            Do you really want to unsubscribe?
          </div>
          <div className="flex justify-center">
            <button
              type="button"
              className="qs-btn qs-btn-primary"
              onClick={handleUnsubscribe}
            >
              Unsubscribe
            </button>
            {/* <button type="button" onClick={() => navigate(-1)}>Cancel</button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unsubscribe;
